<template>
  <container>
    <div class="repay">
      <div class="list-header">
        还款信息
      </div>
      <!--借款本息 -->
      <mu-flexbox orient="vertical" class="repayInfo">
        <mu-flexbox-item class="amountTotal">
          <mu-flexbox>
            <mu-flexbox-item text-align="left">
              应还总额
            </mu-flexbox-item>
            <mu-flexbox-item text-align="right">
              <span>{{(Number(nowPhase.amount) + Number(nowPhase.finalPrincipal) +Number(nowPhase.prepayServiceFee))|money}}</span>
            </mu-flexbox-item>
          </mu-flexbox>
        </mu-flexbox-item>

        <mu-flexbox-item v-show="loanExpand">
          <mu-flexbox>
            <mu-flexbox-item text-align="left">本期应还金额</mu-flexbox-item>
            <mu-flexbox-item text-align="right"><span>{{nowPhase.amount|money}}</span></mu-flexbox-item>
          </mu-flexbox>
        </mu-flexbox-item>

        <mu-flexbox-item v-show="loanExpand">
          <mu-flexbox>
            <mu-flexbox-item text-align="left">剩余本金</mu-flexbox-item>
            <mu-flexbox-item text-align="right"><span>{{nowPhase.finalPrincipal|money}}</span></mu-flexbox-item>
          </mu-flexbox>
        </mu-flexbox-item>

        <mu-flexbox-item v-show="loanExpand">
          <mu-flexbox>
            <mu-flexbox-item text-align="left">提前结清服务费</mu-flexbox-item>
            <mu-flexbox-item text-align="right"><span>{{nowPhase.prepayServiceFee|money}}</span></mu-flexbox-item>
          </mu-flexbox>
        </mu-flexbox-item>

        <div class="iconTextContainer"><span class="iconText primary">应</span></div>
        <icon class="iconContainer" :size="18" :value="loanExpand?'up':'down'" @click.native="loanExpand = !loanExpand;$reportLog('total_amount', 'btn', '提前结清页-点击应还总额')" color="#bcbcbc"></icon>

      </mu-flexbox>

      <!--已还金额 -->
      <mu-flexbox class="repayInfo">
        <mu-flexbox-item text-align="left" class="amountTotal">
          已还金额
        </mu-flexbox-item>
        <mu-flexbox-item text-align="right" class="amountTotal">
          <span>{{nowPhase.totalRepayAmount|money}}</span>
        </mu-flexbox-item>
        <div class="iconTextContainer"><span class="iconText repaied">已</span></div>
      </mu-flexbox>

      <!--减免总额 -->
      <mu-flexbox orient="vertical" class="repayInfo" v-if="repay.deductionTotal > 0 &amp;&amp; nowPhase.reducePhaseServiceFee > 0">
        <mu-flexbox-item class="amountTotal">
          <mu-flexbox>
            <mu-flexbox-item text-align="left">
              减免总额
            </mu-flexbox-item>
            <mu-flexbox-item text-align="right">
              <span>-{{nowPhase.reducePhaseServiceFee|money}}</span>
            </mu-flexbox-item>
          </mu-flexbox>
        </mu-flexbox-item>

        <mu-flexbox-item v-show="deductionExpand" v-if="repay.reducePhaseServiceFee > 0">
          <mu-flexbox>
            <mu-flexbox-item text-align="left">减免期缴服务费</mu-flexbox-item>
            <mu-flexbox-item text-align="right"><span>-{{nowPhase.reducePhaseServiceFee|money}}</span></mu-flexbox-item>
          </mu-flexbox>
        </mu-flexbox-item>

        <mu-flexbox-item v-show="deductionExpand" v-if="repay.reducePhaseServiceFee > 0">
          <mu-flexbox>
            <mu-flexbox-item text-align="left">提前结清服务费减免</mu-flexbox-item>
            <mu-flexbox-item text-align="right"><span>-{{nowPhase.reducePrepayPenalFee|money}}</span></mu-flexbox-item>
          </mu-flexbox>
        </mu-flexbox-item>

        <div class="iconTextContainer"><span class="iconText warning">减</span></div>
        <icon class="iconContainer" :size="18" :value="deductionExpand?'up':'down'" color="#bcbcbc" @click.native="deductionExpand = !deductionExpand;$reportLog('account_balance_reduce', 'btn', '提前结清页-点击账户余额扣减')"></icon>
      </mu-flexbox>

      <!--账户余额 -->
      <!--<div class="lastItem">-->
      <!--<mu-flexbox class="repayInfo">-->
      <!--<mu-flexbox-item text-align="left" class="amountTotal">-->
      <!--账户余额-->
      <!--</mu-flexbox-item>-->
      <!--<mu-flexbox-item text-align="right" class="amountTotal">-->
      <!--<span>-{{accountDeduction / 100 | money}}</span>-->
      <!--</mu-flexbox-item>-->
      <!--<div class="iconTextContainer"><span class="iconText sendray">余</span></div>-->
      <!--</mu-flexbox>-->
      <!--</div>-->
      <!--账户余额 -->
      <div class="lastItem">
        <mu-flexbox orient="vertical" class="repayInfo">
          <mu-flexbox-item class="amountTotal">
            <mu-flexbox>
              <mu-flexbox-item text-align="left">
                账户余额扣减
              </mu-flexbox-item>
              <mu-flexbox-item text-align="right">
                <span>{{accountDeduction / 100 | money}}</span>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-flexbox-item>

          <mu-flexbox-item v-show="accountExpand">
            <mu-flexbox>
              <mu-flexbox-item text-align="left">扣减后剩余余额</mu-flexbox-item>
              <mu-flexbox-item text-align="right"><span>{{accountRemain / 100 | money}}</span></mu-flexbox-item>
            </mu-flexbox>
          </mu-flexbox-item>

          <div class="iconTextContainer"><span class="iconText sendray">余</span></div>
          <icon class="iconContainer" :value="accountExpand?'up':'down'" color="#bcbcbc" :size="20"  @click.native="accountExpand = !accountExpand;$reportLog('account_balance_reduce', 'btn', '提前结清页-点击账户余额扣减')"></icon>
        </mu-flexbox>
      </div>


      <!--应付金额 -->
      <mu-flexbox class="repayInfo fullline" orient="vertical">
        <mu-flexbox-item text-align="right" class="payCell">
          <span style="font-size: 1.5rem">应付金额</span>
          <span class="payAmount">{{shouldPay/100|money|toSplit}}  </span><span style="font-size: 1.5rem">元</span>
        </mu-flexbox-item>
        <mu-flexbox-item text-align="right">
          <span>剩余未结清期数:</span>
          <span v-text="(nowPhase.period - nowPhase.phase) + '期'"></span>
        </mu-flexbox-item>
      </mu-flexbox>
      <!--立即还款 -->
      <mu-button class="payBotton" :height="5.4" @click.native="pay" style="margin: 0">立即还款</mu-button>

      <!---支付-->
      <mu-popup position="bottom" :open="showPay" @close="showPay = false">
        <pay :amount="shouldPay" :repay-apply-id="repayApplyId" :jiea-loan-id="Number(jieaLoanId)" :jiea-repay-type="2" :core-account-customer-id="repayInfo.coreAccountCustomerId||0" @pay="payCallback">
          <!--<p class="pay-remain">剩余结清期数：<span v-text="(nowPhase.period - ƒ)+ '期'"></span></p>-->
        </pay>
      </mu-popup>
    </div>
  </container>
</template>
<style lang="less" rel="stylesheet/less">
  @import "repay";

  .pay-remain {
    font-size: @normalTextFontSize;
    color: @tip;
  }
</style>
<script  >
  import { mapGetters } from 'vuex';
  import { mixinRepay } from '../../utils/mixin/repay';
  import { parseToInt } from '../../utils/math';
  import { fixedFloat2 } from '../../utils/utils';

  export default {
    name: 'repay',
    mixins: [mixinRepay],
    data() {
      return {
        repay: {
          // 借款本息
          totalPrincipal: 65600,
          // 本金
          shouldPrincipal: 60000,
          // 服务费
          phaseServiceFee: 100,
          // 减免总额
          deductionTotal: 5600,
          // 减免服务费
          reducePhaseServiceFee: 1000,
          // 账户余额
          account: 900,
          // 应付金额
          pay: 62800,
          // 总期数
          period: 24,
          // 已还期数
          repayedPhase: 1
        },
        // 借款本息展开
        loanExpand: false,
        // 减免总额展开
        deductionExpand: false,
        // 显示支付组件
        showPay: false,
        // 还款申请记录ID
        repayApplyId: 0,
        // apply 返回jiea进件id
        jieaLoanId: -1,
        // 账户余额扣减
        accountExpand: false
      };
    },
    filters: {
      money(_val) {
        let val = Number(_val);
        if (isNaN(val)) {
          return '';
        }
        return `${val.toFixed(2)} 元`;
      },
      toSplit(val) {
        return val.split('元')[0];
      }
    },
    computed: {
      ...mapGetters(['repayInfo', 'nowPhase']),
      // 提前还款应还金额 = 应还金额 + 剩余本金 + 提前结清服务费 - 已还金额 - 提前结清服务费减免 - 提前还款违约金减免金额 - 账户余额
      shouldPay() {
        const rate = 100;
        const m = Number(this.nowPhase.amount) * rate + Number(this.nowPhase.finalPrincipal)
          * rate + Number(this.nowPhase.prepayServiceFee) * rate - Number(this.nowPhase.totalRepayAmount)
          * rate - Number(this.nowPhase.reducePhaseServiceFee) * rate - Number(this.nowPhase.reducePrepayPenalFee)
          * rate - Number(this.repayInfo.accountAmount) * rate;
        return m >= 0 ? m : 0;
      },
      accountDeduction() {
        const rate = 100;
        let totalReduce = Number(this.nowPhase.totalRepayAmount) * rate
          - Number(this.nowPhase.reducePhaseServiceFee) * rate - Number(this.nowPhase.reducePrepayPenalFee) * rate;
        let totalAmount = Number(this.nowPhase.amount) * rate + Number(this.nowPhase.finalPrincipal) * rate
          + Number(this.nowPhase.prepayServiceFee) * rate;
        let accountAmount = Number(this.repayInfo.accountAmount) * rate;

        let m = (totalAmount - totalReduce) - accountAmount > 0 ? accountAmount : (totalAmount - totalReduce);
        return m >= 0 ? m : 0;
      },
      // 扣减后剩余余额
      accountRemain() {
        return parseToInt(Number(this.repayInfo.accountAmount)) - this.accountDeduction;
      }
    },
    methods: {
      async pay() {
        this.$reportLog('repay', 'btn', '提前结清页-点击立即还款');
        // 更新本地store user state
        await this.$store.dispatch('fetchUserState');
        // 创建还款申请单
        await this.createRepayApply(2);
        // 用户账户余额已经足够还款
        console.log('用户账户余额已经足够还款', fixedFloat2(this.shouldPay));
        if (fixedFloat2(this.shouldPay) === '0.00') {
          return await this.repayWithAccount(2);
        }


        // 账户余额不够，继续支付
        this.$reportLog('payment_details', 'popupStart', '弹窗-支付详情页');
        this.showPay = true;
      },
      // 支付回调
      payCallback(data) {
        if (data && data.success) {
          // 支付成功
          this.$router.replace({ name: 'processing', params: { type: 'repay' } });
        }
        else {
          this.payConfirm();
        }
        this.showPay = false;
      }
    }
  };
</script>
